import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "star-on",
  "use": "star-on-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"star-on\"><defs><style>#star-on .cls-1{fill:none}</style></defs><title>资源 87</title><g id=\"star-on_图层_2\" data-name=\"图层 2\"><g id=\"star-on_图层_1-2\" data-name=\"图层 1\"><path id=\"star-on_Rectangle_35_Copy_10\" data-name=\"Rectangle 35 Copy 10\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"star-on_star-o\"><path id=\"star-on_Shape\" d=\"M16.25 22.22L12 19.88l-4.23 2.34a2.1 2.1 0 0 1-1 .25 2 2 0 0 1-2-2v-.33L5.62 15l-3.53-3.61A2 2 0 0 1 3.24 8L8 7.23l2.14-4.56a2 2 0 0 1 3.68 0L16 7.23l4.8.74a2 2 0 0 1 1.14 3.42L18.41 15l.83 5.1a2 2 0 0 1-1.68 2.33 2.06 2.06 0 0 1-1.31-.23z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/star-on.svg
// module id = wOTZ
// module chunks = 6